/*
 * Be sure to test this page in both signed-in and signed-out. this feature has been a wild ride, folks.
 * */

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import get from "lodash/get";
import partial from "lodash/partial";
import { fetchPublicShowForSubscriber } from "../../../action_managers/public_show";
import { fetchSubscription } from "../../../action_managers/subscriptions";
import ExpandableText from "../../lib/expandable_text/expandable_text";
import { Grid, Row, Col } from "react-bootstrap";
import moment from "moment";
import { formatDuration } from "../../../lib/duration";
import "./sponsor_show_page.scss";
import Divider from "../../lib/divider";
import { CSSTransition } from "react-transition-group";
import { classNames, If } from "react-extras";
import MediaPlayer from "../../lib/media_player/media_player";
import { showModal } from "../../../actions/modal";
import { SPONSORSHIP_MODAL, CONFIRMATION_MODAL, TIP_MODAL } from "../../modals/modal_root";
import { cancelSubscription, getPaymentMethod } from "../../../action_managers/subscriptions";
import { fetchPublicShow } from "../../../action_managers/public_show";
import { formatMoney } from "../../../lib/format-money";
import ExclusiveTag from "../../lib/exclusive_tag";
import { LISTEN_ON_MODAL } from "../../modals/modal_root";
import { AlbumArt } from "../../lib/album-art";
import { withPageTitle } from "../../lib/WithPageTitle";
import HighlightBox from "../../lib/highlight-box";
import { showWarning } from "../../../actions/app";
import { showTip } from "../../../actions/shows";
import { getSubscriptionUUID } from "../../../lib/uuid";
import LoggedOutFrame from "../../lib/logged_out_frame";
import { addRole } from "../../../action_managers/account";
import UserRoles from "../../../constants/roles";
import { userHasRole } from "../../../lib/user";

class SponsorShowPage extends Component {
  state = {
    expandedEpisode: "",
    subscription: {},
    currentCardID: "",
  };

  componentDidMount() {
    if (this.props.user && !userHasRole(this.props.user, UserRoles.Sponsor)) {
      this.props.addRole(this.props.user, UserRoles.Sponsor);
    }
    this.getShowAndSubscription().then(() => {
      const sub = this.getSubscription();
      const show = this.getShow();

      if (this.props.resubscribe) {
        if (sub && sub.type === "exclusive") {
          this.showExclusiveModal(show);
        } else {
          this.showDonationModal(show, sub.amount);
        }
      }
    });
  }

  getSubscriptionUUID = () => getSubscriptionUUID(get(this.props.user, "uuid"), this.getShowUUID());

  getShowAndSubscription = async () => {
    let sub;
    if (this.props.user) {
      sub = this.props.fetchSubscription(this.getSubscriptionUUID());
      await this.props.fetchPublicShowForSubscriber(this.getShowUUID());
    } else {
      await this.props.fetchPublicShow(this.getShowUUID());
    }

    return sub;
  };

  getSubscription = () => {
    return get(this.props.subscriptions, this.getSubscriptionUUID());
  };

  getShowUUID = () => {
    return get(this.props, "match.params.showUUID");
  };

  getShow = () => get(this.props, ["publicShows", this.getShowUUID()]);
  renderShowTitle = opts => {
    let className = "hidden-xs visible-sm visible-md visible-lg visible-xl";
    if (opts && opts.forMobile) {
      className = "visible-xs hidden-sm hidden-md hidden-lg hidden-xl text-center";
    }
    const show = this.getShow();
    if (!show) return null;
    return (
      <div className={className}>
        <h1>{show.title}</h1>
        <Divider smallMargin />
        <If condition={!opts || !opts.forMobile}>
          <ExpandableText dangerousText={show.description} heightToWidth={4} />
        </If>
      </div>
    );
  };

  cancelSubscription = () => {
    return this.props.cancelSubscriptionModal(get(this.getSubscription(), "uuid"), uuid => {
      return this.props.cancelSubscription(uuid).then(() => {
        return this.getShowAndSubscription();
      });
    });
  };

  goToSignin = () => {
    this.props.history.push({
      pathname: "/sign-up/sponsor",
      search: `?goto=/shows/${this.getShowUUID()}/sponsor`,
    });
  };

  renderEpisodeList = () => {
    const show = this.getShow();
    if (!show) return null;

    return (
      <div className={"episode-list"}>
        {show.episodes.map(episode => {
          const expanded = this.state.expandedEpisode === episode.uuid;
          const cannotAccess = !episode.streamURL;
          return (
            <div
              key={episode.uuid}
              className={classNames("episode-list-item", { "episode-list-collapsed": !expanded })}
              onClick={() => {
                if (cannotAccess) {
                  return;
                }
                expanded
                  ? this.setState({ expandedEpisode: "" })
                  : this.setState({ expandedEpisode: episode.uuid });
              }}>
              <div
                className={classNames(
                  "episode-title flex-row-container align-center",
                  "bold",
                  cannotAccess && "cannot-access"
                )}>
                <span className={"episode-title-text"}>{episode.title}</span>
                {this.isExclusive(episode) && (
                  <ExclusiveTag disabled={cannotAccess}>exclusive</ExclusiveTag>
                )}
              </div>
              <div className={classNames("episode-published-at", cannotAccess && "cannot-access")}>
                {moment.unix(episode.publishedAt).format("MMM DD, YYYY")} -{" "}
                {formatDuration(episode.duration)}
              </div>
              <CSSTransition
                classNames={"episode-list"}
                mountOnEnter={true}
                unmountOnExit={true}
                in={expanded}
                timeout={300}>
                <div onClick={e => e.stopPropagation()}>
                  <div
                    className="episode-description"
                    dangerouslySetInnerHTML={{
                      __html: episode.description,
                    }}
                  />
                  {episode.streamURL && (
                    <MediaPlayer
                      mediaFileURL={episode.streamURL}
                      menuItems={{
                        Download: () => this.download(episode),
                      }}
                    />
                  )}
                </div>
              </CSSTransition>
            </div>
          );
        })}
      </div>
    );
  };

  download = episode => {
    window.open(episode.streamURL, "_blank");
  };

  isExclusive = episode => {
    return !episode.shouldPublishToNonSubscribers && episode.shouldPublishToSubscribers;
  };

  subscriptionIsActive = () => {
    return get(this.getSubscription(), "state") === "active";
  };

  subscriptionIsExclusive = () => {
    return this.subscriptionIsActive() && get(this.getSubscription(), "type") === "exclusive";
  };

  onSubscriptionDone = () => {
    this.getShowAndSubscription();
  };

  showModal = props => {
    this.props.showModal(props);
  };

  isExclusiveEnabled = () => {
    return get(this.getShow(), "subscriptionDetails.exclusiveContentEnabled", false);
  };

  isDonationsEnabled = () => {
    return get(this.getShow(), "subscriptionDetails.recurringDonationsEnabled", false);
  };

  launchTipModal = () => {
    return this.props.launchTipModal({
      mode: "tip",
    });
  };

  perTextFromInterval = interval => {
    if (!interval) {
      return "";
    }

    if (interval === "weekly") {
      return "per week";
    }
    if (interval === "annual") {
      return "per year";
    }

    return "per month";
  };

  renderLeft = () => {
    const show = this.getShow();
    if (!show) return null;

    return (
      <div className={"left-column"}>
        <div className="hidden-xs visible-sm visible-md visible-lg visible-xl">
          <AlbumArt src={show.imageURL} alt="album-art" />
        </div>
        <div className="visible-xs hidden-sm hidden-md hidden-lg hidden-xl">
          <Row>
            <Col xs={6} xsOffset={3}>
              <AlbumArt src={show.imageURL} alt="album-art" />
            </Col>
          </Row>
        </div>

        {this.renderShowTitle({ forMobile: true })}
        <div className="link-row bold">
          <If condition={this.subscriptionIsExclusive()}>
            <button
              onClick={() =>
                this.props.launchListenOnModal({ subscriptionUUID: this.getSubscriptionUUID() })
              }
              className={"btn btn-primary width-100"}>
              Listen In App
            </button>
          </If>
        </div>
        <div className="sponsor-show-info">
          <If condition={this.isExclusiveEnabled() && !this.subscriptionIsActive()}>
            <div className="header bold">EXCLUSIVE CONTENT</div>
            <div className="content-section">
              <p>Get access to exclusive content from this podcast.</p>
              <If condition={!this.subscriptionIsActive()}>
                <div className="fake-link" onClick={show => this.showExclusiveModal(show)}>
                  Unlock Exclusive Content
                </div>
              </If>
              <If condition={this.subscriptionIsActive()}>
                <ExclusiveTag className={"width-100"}>
                  Sponsoring at {formatMoney(get(this.state, "subscription.amount"))}{" "}
                  {this.perTextFromInterval(get(this.state, "subscription.interval"))}
                </ExclusiveTag>
              </If>
            </div>
          </If>
          <If condition={this.subscriptionIsActive()}>
            <HighlightBox
              title={"You're sponsoring this podcast for"}
              value={`${formatMoney(
                get(this.getSubscription(), "amount")
              )} ${this.perTextFromInterval(get(this.getSubscription(), "interval"))}`}
            />
            <HighlightBox
              title={"Your next payment will be on"}
              value={moment
                .unix(get(this.getSubscription(), "nextPaymentAt", 0))
                .format("MMMM Do YYYY")}
            />
          </If>
        </div>
        <If condition={this.isDonationsEnabled()}>
          <div className="sponsor-show-info">
            <If condition={!this.subscriptionIsActive()}>
              <div className="header bold">DONATIONS</div>
              <div className="content-section">
                <p>Set your own one-time or monthly donation amount.</p>

                <If condition={!this.subscriptionIsActive()}>
                  <div className="fake-link" onClick={show => this.showDonationModal(show)}>
                    Recurring Donation
                  </div>
                </If>
                <div className="fake-link margin-top--small" onClick={this.launchTipModal}>
                  One-Time Donation
                </div>
              </div>
            </If>
          </div>
        </If>
        <If condition={this.subscriptionIsActive()}>
          <div className={"bold bottom-links"}>
            <button className={"fake-link"} onClick={this.showEditModal}>
              Update Payment
            </button>
          </div>
          <div className={"bold bottom-links"}>
            <button className={"fake-link"} onClick={this.cancelSubscription}>
              Cancel Sponsorship
            </button>
          </div>
        </If>
      </div>
    );
  };

  showExclusiveModal = show => {
    this.showModal({
      mode: "subscribe",
      show,
      onDone: this.onSubscriptionDone,
    });
  };

  showDonationModal = (show, amount = 0) => {
    this.showModal({
      mode: "custom",
      show,
      amount,
      onDone: this.onSubscriptionDone,
      interval: "monthly",
    });
  };

  showEditModal = () => {
    this.showModal({
      mode: this.getSubscription().type === "donation" ? "custom" : "subscribe",
      amount: this.getSubscription().amount,
      onDone: this.onSubscriptionDone,
      currentCardID: this.state.currentCardID,
      isEdit: true,
    });
  };

  render() {
    return (
      <LoggedOutFrame
        noBar={true}
        hideHeader={!!this.props.user}
        signInLink={`/sign-in/sponsor?goto=${encodeURIComponent(
          `/shows/${this.getShowUUID()}/sponsor`
        )}`}
        signUpLink={`/sign-up/sponsor?goto=${encodeURIComponent(
          `/shows/${this.getShowUUID()}/sponsor`
        )}`}>
        <div className={"sponsor-show-page"}>
          <Grid>
            <Row>
              <Col sm={3}>{this.renderLeft()}</Col>
              <Col sm={8} smOffset={1}>
                {this.renderShowTitle()}
                {this.renderEpisodeList()}
              </Col>
            </Row>
          </Grid>
        </div>
      </LoggedOutFrame>
    );
  }
}

function mapStateToProps(state) {
  return {
    publicShows: state.publicShows,
    subscriptions: state.subscriptions.subscriptions,
    user: state.user.user,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    showModal: props => showModal(SPONSORSHIP_MODAL, props),
    fetchPublicShow,
    cancelSubscriptionModal: (uuid, callback) => {
      return showModal(CONFIRMATION_MODAL, {
        modalTitle: "Are you sure?",
        confirmationMessage:
          "If you cancel your sponsorship, you'll no longer be supporting this podcaster's work.  You'll also lose access to any exclusive content you've earned.",
        callback: () => callback(uuid),
        actionButtonName: "Stop Sponsoring",
      });
    },
    cancelSubscription,
    fetchPublicShowForSubscriber,
    fetchSubscription,
    getPaymentMethod,
    showWarning,
    addRole,
    showTip,
    launchListenOnModal: partial(showModal, LISTEN_ON_MODAL),
    launchTipModal: partial(showModal, TIP_MODAL),
  })(withPageTitle(SponsorShowPage, "Sponsor Show"))
);
